<script setup lang="ts">
const config = useAppConfig()

const {value} = defineProps<{ value?: any }>()
</script>

<template>
  <DevOnly v-if="config.debug">
    <pre wrap>
      <slot>
        {{ value }}
      </slot>
    </pre>
  </DevOnly>
</template>

<style scoped>

</style>
